//
//
//
//
//
//

// import { previewDataInterface } from '@/api/systemData/dataInterface'
import request from "@/utils/request";
import { EventBus } from "@/api/event-bus";
export default {
  name: "resetting",
  props: {
    transvalue: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      visible: false,
      pageConfig: []
    };
  },
  watch: {},
  computed: {},
  created: function created() {},
  methods: {
    getColumnWidths: function getColumnWidths() {
      EventBus.$emit("executeMethod");
    }
  }
};